import Dots from "./SVG/dots.svg?react";

const DotsIcon = () => {
  return <Dots />;
};

export default DotsIcon;
